var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('button',{on:{"click":_vm.exportPDF}},[_vm._v("Export PDF")]),_c('ul',_vm._l((_vm.todos),function(todo){return _c('li',{key:todo.id},[_vm._v(" "+_vm._s(todo.title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }